module.exports = __webpack_public_path__ + "media/images/saavan-log-4673f8bdab2e9ba204fbf10640196366.svg";